import { ControlButtonProps } from '@xyflow/react';

import {
  FullscreenName,
  useFullscreenContext,
} from '@/components/Fullscreen/fullscreen.context';
import { Maximize01Icon } from '@/components/icons/Maximize01Icon';
import { Minimize01Icon } from '@/components/icons/Minimize01Icon';

import { CONTROL_BUTTON_ICON_SIZE, ControlButton } from './ControlButton';

export interface FullscreenButtonProps extends ControlButtonProps {
  name: FullscreenName;
}

export function FullscreenButton({
  children: _,
  name,
  ...props
}: FullscreenButtonProps) {
  const { isFullscreen, handles } = useFullscreenContext();
  const handle = handles?.[name];

  if (isFullscreen) {
    return (
      <ControlButton
        variant="primary"
        onClick={handle?.exit} // This must be called directly in the onClick to satisfy browser security requirements
        title="exit fullscreen"
        aria-label="exit fullscreen"
        {...props}
      >
        <Minimize01Icon size={CONTROL_BUTTON_ICON_SIZE} />
      </ControlButton>
    );
  }

  return (
    <ControlButton
      variant="secondary"
      onClick={handle?.enter} // This must be called directly in the onClick to satisfy browser security requirements
      title="fullscreen"
      aria-label="fullscreen"
      {...props}
    >
      <Maximize01Icon size={CONTROL_BUTTON_ICON_SIZE} />
    </ControlButton>
  );
}
